// Libs
import classNames from 'classnames/bind';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
// Components, Layouts, Pages
import { BaseConversationItem } from '~/components/common';
import { ConversationInputSearch } from '~/components/module/conversation';
// Others
import { IConversation } from '~/utils/interface/conversation';
import { DEFAULT_NUMBER_ZERO } from '~/utils/constants/common';
// Styles, images, icons
import styles from './ListConversation.module.scss';

type Props<T> = {
  conversations: T[];
  conversationSelected?: string;
  searchValue?: string;
  hasMoreConversation: boolean;
  onSearch?: (value: string) => void;
  onConversationClick?: (accountId: string) => void;
  onLoadMoreConversation?: () => void;
};

const cx = classNames.bind(styles);

const ListConversation = <T extends IConversation>(props: Props<T>) => {
  //#region Destructuring Props
  const {
    conversations,
    conversationSelected,
    searchValue,
    hasMoreConversation,
    onSearch,
    onConversationClick,
    onLoadMoreConversation,
  } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/conversation']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleSearchChange = (value: string) => {
    onSearch && onSearch(value);
  };

  const handleConversationClick = (conversation: IConversation) => {
    onConversationClick && onConversationClick(conversation.id);
  };

  const handleLoadMoreConversation = () => {
    onLoadMoreConversation && onLoadMoreConversation();
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='listConversationComponent' className={cx('container')}>
      <Box component={'div'} className={cx('searchConversation')}>
        <ConversationInputSearch width={'100%'} onChange={handleSearchChange} value={searchValue} />
      </Box>

      <Box id='listConversation' component={'div'} className={cx('listConversation')}>
        <InfiniteScroll
          dataLength={conversations.length}
          next={handleLoadMoreConversation}
          hasMore={hasMoreConversation}
          loader={
            <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} height={35}>
              <CircularProgress size={24} />
            </Stack>
          }
          scrollThreshold={0.8}
          scrollableTarget={'listConversation'}
          {...(conversations?.length === DEFAULT_NUMBER_ZERO && {
            endMessage: (
              <Stack
                component={'div'}
                direction={'row'}
                alignItems={'center'}
                justifyContent={'center'}
                className={cx('noDataGroup')}
              >
                <Typography component={'span'} className={cx('noDataContent')}>
                  {t('common_no_data_available', { ns: 'common/base' })}
                </Typography>
              </Stack>
            ),
          })}
        >
          {Array.isArray(conversations) &&
            conversations?.length > DEFAULT_NUMBER_ZERO &&
            conversations?.map((conversation) => (
              <Box component={'div'} className={cx('conversationItem')}>
                <BaseConversationItem
                  isTyping={conversation.isTyping}
                  conversation={conversation}
                  key={conversation?.id}
                  selected={conversation?.id === conversationSelected}
                  onClick={handleConversationClick}
                />
              </Box>
            ))}
        </InfiniteScroll>
      </Box>
    </Box>
  );
};

export default ListConversation;
